import { ArrowDownRight, ArrowUpRight, Circle, RotateCcw, Sparkles, XCircle } from "lucide-react";

export const MARKET_STATUS = {
  NIEUW: {
    key: "NIEUW",
    label: "Nieuw",
    hint: "Sinds laatste scan",
    chip: "border-emerald-300 bg-emerald-50 text-emerald-800",
    icon: Sparkles,
    iconColor: "text-emerald-600",
  },
  PRIJS_VERLAAGD: {
    key: "PRIJS_VERLAAGD",
    label: "Prijs verlaagd",
    hint: "Vraagprijs verlaagd",
    chip: "border-amber-300 bg-amber-50 text-amber-900",
    icon: ArrowDownRight,
    iconColor: "text-amber-600",
  },
  PRIJS_VERHOOGD: {
    key: "PRIJS_VERHOOGD",
    label: "Prijs verhoogd",
    hint: "Vraagprijs verhoogd",
    chip: "border-slate-300 bg-slate-50 text-slate-700",
    icon: ArrowUpRight,
    iconColor: "text-slate-500",
  },
  BESTAAND: {
    key: "BESTAAND",
    label: "Bestaand",
    hint: "Nog actief",
    chip: "border-slate-300 bg-slate-50 text-slate-600",
    icon: Circle,
    iconColor: "text-slate-400",
  },
  TERUG_ONLINE: {
    key: "TERUG_ONLINE",
    label: "Terug online",
    hint: "Opnieuw beschikbaar",
    chip: "border-blue-300 bg-blue-50 text-blue-800",
    icon: RotateCcw,
    iconColor: "text-blue-600",
  },
  VERDWENEN: {
    key: "VERDWENEN",
    label: "Verdwenen",
    hint: "Niet meer actief",
    chip: "border-red-300 bg-red-50 text-red-800",
    icon: XCircle,
    iconColor: "text-red-600",
  },
};

export const LEGEND_ORDER = [
  "NIEUW",
  "PRIJS_VERLAAGD",
  "BESTAAND",
  "TERUG_ONLINE",
  "VERDWENEN",
];

export const statusMeta = (status) => MARKET_STATUS[status] || MARKET_STATUS.BESTAAND;
